var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeginTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 959,
    height: 159,
    viewBox: "0 0 959 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1878_11534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.3 0C479.3 0 466.397 6.69538 461.702 12.7591C457.008 18.8229 442.609 17.6859 435.163 4.98995C435.163 4.98995 433.013 26.1728 427.94 32.0069C422.867 37.8409 408.858 38.375 403.934 35.8369C403.934 35.8369 415.616 53.6377 412.555 63.9736C409.495 74.3095 395.004 78.3233 395.004 78.3233C395.004 78.3233 419.434 85.3 420.592 97.2151C421.75 109.13 414.206 117.462 414.206 117.462C414.206 117.462 439.863 106.196 446.357 118.955C452.852 131.714 452.365 140.006 452.365 140.006C452.365 140.006 470.254 112.587 494.988 132.644C494.988 132.644 491.119 91.0537 527.971 103.796C527.971 103.796 503.334 73.7755 535.004 61.4298C535.004 61.4298 497.889 44.0999 517.802 20.5398C517.802 20.5398 480.01 33.5113 479.305 0.00574218L479.3 0Z",
    fill: "#FF4D1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.595 72.9256C444.732 72.9256 441.184 71.4441 438.902 69.8248L440.026 68.2285C442.514 69.9914 446.698 71.5819 450.991 70.7436C454.643 70.0316 457.767 67.683 460.271 63.7668L461.911 64.8234C459.102 69.2047 455.554 71.8461 451.364 72.6615C450.435 72.8452 449.507 72.9256 448.595 72.9256Z",
    fill: "#1C1C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.154 67.3328C470.29 67.3328 466.742 65.8513 464.461 64.232L465.584 62.6357C468.072 64.3985 472.257 65.9891 476.55 65.1508C480.201 64.4387 483.325 62.0902 485.83 58.174L487.469 59.2306C484.661 63.6119 481.113 66.2533 476.917 67.0686C475.982 67.2524 475.06 67.3328 474.148 67.3328H474.154Z",
    fill: "#1C1C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.692 86.3509C461.534 86.3509 460.622 86.2131 460.066 85.9604L460.875 84.1861C462.033 84.7144 467.776 84.4732 473.657 81.5906C477.555 79.6785 482.519 76.0666 484.026 69.6871L485.924 70.135C484.239 77.2553 478.787 81.2518 474.511 83.3477C470.178 85.4723 465.638 86.3566 462.692 86.3566V86.3509Z",
    fill: "#1C1C22"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8938 157.724H192.612C193.13 142.09 190.308 111.476 174.944 114.088C155.735 117.355 128.791 132.735 159.005 130.042C189.223 127.35 152.087 59.1128 114.261 61.2261C76.4356 63.3431 21.5058 111.4 48.7841 130.042C62.9906 145.612 57.2296 84.868 14.6025 117.355C-1.69447 133.504 0.00380005 150.996 2.88622 157.724H2.8938Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M831.748 126.357H957.02C957.362 116.016 955.499 95.767 945.354 97.4947C932.669 99.6555 914.879 109.828 934.829 108.047C954.782 106.267 930.261 61.1326 905.284 62.5304C880.308 63.9307 844.038 95.7166 862.05 108.047C871.43 118.345 867.626 78.1677 839.479 99.6555C828.718 110.336 829.84 121.906 831.743 126.357H831.748Z",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M729.223 46.3566C729.223 46.3566 745.978 55.1185 745.329 78.6412C748.814 74.4127 759.771 57.8888 775.93 59.5938",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M685.059 90.4482C685.059 90.4482 703.89 88.8238 715.954 109.015C716.625 103.572 717.007 83.7389 731.552 76.4832",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1878_11534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white",
    transform: "translate(395)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginTop);
export default __webpack_public_path__ + "static/media/begin_top.b3c7cc9097072e2c96b8cf335295de74.svg";
export { ForwardRef as ReactComponent };